import { usePlatformQuery } from '@dashboard/generated/wp/authentication';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';

export default function useCurrentWpPlatform() {
  const platformId = useCurrentPlatformId();
  return usePlatformQuery({ variables: { id: platformId } });
}
